module.exports = __webpack_public_path__ + "static/20230619_015-f2468b546496f5456002b9b5fd6725e6.jpg";